var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWjManualeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1034 4173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.046,189.8v-6.3H124.955v6.3H121.5v2.1l9.182,8.035V204.5h2.546v-4.565L142.5,191.9v-2.1Z",
    transform: "translate(914 -4355)",
    fill: "#16b240"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.545,
    height: 4.565,
    transform: "translate(1044.682 -4155.065)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,189.8h-3.454v-6.3H124.955v6.3H121.5v2.1l9.182,8.035h2.545L142.5,191.9Z",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.986,187.445l2.051,5.449,2.046-5.449h1.6v7.109h-1.23v-2.343l.122-3.135-2.1,5.478h-.883l-2.1-5.473.122,3.13v2.343h-1.231v-7.109Z",
    transform: "translate(914 -4355)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(1034 -4173)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWjManualeGreen);
export default __webpack_public_path__ + "static/media/wj_manuale_green.9e7dea34577f723e1c83151c2fa758f7.svg";
export { ForwardRef as ReactComponent };